module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1177.8a32dfdb.png";